// UNIVAPLAT-1924: Confirmation modal — short yes/no gate, triggers send POST.
// The message preview lives in the compose modal upstream, not here.
import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminWhatsappService} from '@shared/api/services/v2/admin-whatsapp.service';
import {AdminWhatsappResultModal} from './admin-whatsapp-result.modal';

@Component({
    selector: 'cdss-admin-whatsapp-confirm-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './admin-whatsapp-confirm.modal.html',
})
export class AdminWhatsappConfirmModal implements OnInit {
    @Input() userId!: number;
    @Input() templateSid!: string;
    @Input() variableValues!: Record<string, string>;

    sending = false;

    constructor(
        public modal: NgbActiveModal,
        private adminWhatsappService: AdminWhatsappService,
        private modalService: NgbModal,
    ) {}

    ngOnInit(): void {}

    back(): void { this.modal.dismiss('back'); }

    async send(): Promise<void> {
        this.sending = true;
        try {
            const response = await this.adminWhatsappService.sendMessage(this.userId, {
                templateSid: this.templateSid,
                variables: this.variableValues,
            });
            this.openResultModal(true, response.statusAtSend);
        } catch (err: any) {
            // Use the structured API error if present; fall back to a safe generic message.
            // Never surface err?.message — that can expose the API URL from HttpErrorResponse.
            const msg = err?.error?.message ?? err?.error?.detail ?? 'An unexpected error occurred.';
            this.openResultModal(false, msg);
        } finally {
            this.sending = false;
        }
    }

    private openResultModal(success: boolean, statusMessage: string): void {
        // keyboard: false prevents ESC from dismissing the result modal, ensuring
        // the user clicks Close and the log-refresh signal propagates correctly.
        const resultRef = this.modalService.open(AdminWhatsappResultModal, {keyboard: false, centered: true});
        resultRef.componentInstance.success = success;
        resultRef.componentInstance.statusMessage = statusMessage;
        resultRef.result.then(r => {
            if (r === 'refresh') { this.modal.close('refresh'); }
        }).catch(() => {});
    }
}
